import { css } from '@emotion/react';
import React from 'react';
import BrushStrokeSingleSvg from '../../../assets/svg/scribble-brush.svg';
import BrushStrokeLongSvg from '../../../assets/svg/scribble-long-brush.svg';
import BrushLong from '../../../assets/svg/wordDecorations/brush/brushstroke-extra-long-03.svg';
import BrushShort from '../../../assets/svg/wordDecorations/brush/brushstroke-extra-short-04.svg';
import BrushDouble02 from '../../../assets/svg/wordDecorations/brush/brushstroke-two-lines-02.svg';
import BrushDouble04 from '../../../assets/svg/wordDecorations/brush/brushstroke-two-lines-04.svg';
import { breakpoints } from '../../../utils/styleguide';

export const variants = {
  brush: {
    imgComponent: BrushStrokeSingleSvg,
    wrapper: `
    position: absolute;
    top: -10px;
    right: -50px;
    left: -10px;
    bottom: -14px;
  
  `,
  },
  longBrush: {
    imgComponent: BrushStrokeLongSvg,
    wrapper: `
    position: absolute;
    top: -10px;
    right: -50px;
    left: -30px;
    bottom: -14px;
    ${breakpoints.desktop} {
      width: 270px;
    }
  `,
  },
  shortH1: {
    imgComponent: BrushShort,
    wrapper: `
    top: -10px;
    right: -10px;
    left: -5px;
    bottom: -10px;
    ${breakpoints.desktop} {
      top: -20px;
      right: -10px;
      left: -20px;
      bottom: 0px;
    }
  `,
  },
  longH1: {
    imgComponent: BrushLong,
    wrapper: `
    top: -5px;
    right: -8px;
    left: -8px;
    bottom: -5px;
    ${breakpoints.desktop} {
      left: -20px;
    }
  `,
  },
  Double02: {
    imgComponent: BrushDouble02,
    wrapper: `
    top: -5px;
    right: -8px;
    left: -10px;
    bottom: -5px;
    ${breakpoints.desktop} {
      left: -21px;
      bottom: -28px;
    }
  `,
  },
  Double04: {
    imgComponent: BrushDouble04,
    wrapper: `
    top: -5px;
    right: -8px;
    left: -10px;
    bottom: -5px;
    ${breakpoints.desktop} {
      left: -21px;
      bottom: -28px;
    }
  `,
  },
};

export type BrushVariants = keyof typeof variants;

type Props = {
  children?: React.ReactNode;
  className?: string;
  brushStyle?: string;
  variant?: BrushVariants;
};

const BrushStrokeWord = ({ children, variant = 'brush', brushStyle, className }: Props) => {
  const variantData = variants[variant];
  const BrushStrokeComponent = variantData.imgComponent;
  return (
    <span
      style={{ position: 'relative', zIndex: -1, display: 'inline-block' }}
      className={className}
    >
      <span
        css={css`
          position: absolute;
          ${variantData.wrapper}
          ${brushStyle}
        `}
      >
        <BrushStrokeComponent
          css={css`
            width: 100%;
            height: 100%;
          `}
          aria-hidden="true"
          preserveAspectRatio="none"
        />
      </span>
      <span
        css={css`
          position: relative;
        `}
      >
        {children}
      </span>
    </span>
  );
};

export default BrushStrokeWord;
